import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-symbol-avatars',
  templateUrl: './symbol-avatars.component.html',
  encapsulation: ViewEncapsulation.None
})

export class SymbolAvatarsComponent {
}
